import { render, staticRenderFns } from "./descrizioniProdotti.vue?vue&type=template&id=07e554eb&"
import script from "./descrizioniProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./descrizioniProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports